import React, { createContext, useContext, useEffect, useState } from "react";
import { t as translate, displayName as dn } from "@/i18n";
import api from "@/api";

const LangCtx = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(localStorage.getItem("xtra_lang") || "en");

  useEffect(() => {
    localStorage.setItem("xtra_lang", lang);
  }, [lang]);

  const setLanguage = async (l) => {
    setLang(l);
    if (localStorage.getItem("xtra_token")) {
      try { await api.put("/auth/language", { language: l }); } catch (_) {}
    }
  };

  const t = (key) => translate(lang, key);
  const displayName = (item) => dn(item, lang);

  return (
    <LangCtx.Provider value={{ lang, setLang: setLanguage, t, displayName }}>
      {children}
    </LangCtx.Provider>
  );
};

export const useLang = () => useContext(LangCtx);
